/**
 * CategoryListContainer
 * --
 */
import React from 'react';
import CategoryListPresenter from './CategoryListPresenter';

const CategoryListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <CategoryListPresenter />
    </>
  );
};

export default CategoryListContainer;
